<template>
  <div class="boxDiv">
    <div class="innerBox">
      <div class="sxBox">
        <el-input placeholder="搜索商品名称" class="w300 seekIpt mr20" v-model="queryLimit1"
          @keyup.enter.native="searchPage">
          <i slot="suffix" class="el-input__icon el-icon-search" @click="searchPage"></i>
        </el-input>
        <el-select v-model="queryLimit1" placeholder="筛选商品种类" class="w200 mr20">
          <el-option v-for="item in supplyLists" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <span class="dayTit">采购日期：</span>
        <el-date-picker @change="searchPage" class="w140 mr10" type="date" value-format="yyyy-MM-dd"
          v-model="queryLimit1" placeholder="选择起始日期" :picker-options="beforeDate" clearable></el-date-picker>
        <span class="dayTit">至</span>
        <el-date-picker @change="searchPage" v-model="queryLimit1" value-format="yyyy-MM-dd" class="w140 ml10 mr20"
          type="date" placeholder="选择截止日期" :picker-options="afterDate" clearable></el-date-picker>
        <el-button class="w70" @click="searchPage">重 置</el-button>
        <div class="mt20">
          <el-button type="primary" class="w90 pl" @click="searchPage">批量删除</el-button>
        </div>
      </div>
      <div class="mt20">
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
          @selection-change="selectionChange">
          <el-table-column type="selection" width="80"></el-table-column>
          <el-table-column prop="goodsName" min-width="180" label="商品名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="goodsTypeNum" min-width="80" label="商品种类" show-overflow-tooltip></el-table-column>
          <el-table-column prop="supplyName" min-width="180" label="供应商" show-overflow-tooltip></el-table-column>
          <el-table-column prop="supplyTel" min-width="120" label="联系方式" show-overflow-tooltip></el-table-column>
          <el-table-column prop="buyPerson" min-width="120" label="采购人" show-overflow-tooltip></el-table-column>
          <el-table-column prop="buyDate" min-width="120" label="采购日期" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" min-width="180">
            <template slot-scope="scope">
              <a href="javascript:;" class="operate-a" @click="openEdit(scope.row)">编辑</a>
              <a href="javascript:;" class="operate-a" @click="openDetail(scope.row)">详情</a>
              <a href="javascript:;" class="operate-a" @click="delConfirm(scope.row.id)">删除</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-box mt20">
        <el-pagination background @size-change="pageSizeChange" @current-change="pageCurrentChange"
          :current-page="queryLimit.pageNum" :page-sizes="[10, 20, 30, 40,50]" :page-size="queryLimit.pageSize"
          layout="total,prev, pager, next, sizes, jumper" :total="tableData.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      queryLimit1: '',
      supplyLists:[],
      tableData: [],
      queryLimit: {
        pageNum: 1,
        goodsName: "",
        endDate: '',
        startDate: '',
        pageSize: 10
      },
      afterDate: {
        disabledDate: time => {
          let startDate = new Date(this.queryLimit.startDate);
          if (this.queryLimit.startDate) {
            return time.getTime() < startDate - 8.64e7;
          }
        }
      },
      beforeDate: {
        disabledDate: time => {
          let endDate = new Date(this.queryLimit.endDate);
          if (this.queryLimit.endDate) {
            return time.getTime() > endDate || new Date('2017-12-31') > time.getTime();
          } else {
            return time.getTime() < new Date('2017-12-31')
          }
        }
      },
    }
  },
  methods: {
    searchPage(){

    },
    selectionChange(row) {
      // for (let i = 0; i < row.length; i++) {
      //   this.idArr.push(row[i].id)
      // }
    },
    pageCurrentChange(current) {
      // this.queryLimit.pageNum = current;
      // this.getPageData();
    },
    pageSizeChange(size) {
      // this.queryLimit.pageSize = size;
      // this.getPageData();
    },
  },
}
</script>
<style scoped lang="scss">
  .boxDiv{
    padding: 20px 30px;
    background-color: #FFF;
    border-radius: 4px;
    .sxBox{
      padding-bottom: 20px;
      border-bottom: 1px solid #eee;
    }
    .dayTit{
      color: #666;
      font-size: 12px;
    }
    .pagination-box{
      text-align: right;
    }
  }
</style>